import { Box, BoxProps } from '@mui/material'
import { FC } from 'react'

import { useSafeAreaFooterSetting } from '@/lib/safeAreaView'

export type BottomSafeAreaProps = BoxProps & { defaultProps?: BoxProps }

/**
 *
 * @description settings bottom safe area view
 *
 * @param children
 * @param defaultProps
 * @param props
 * @constructor
 *
 * @example
 *
 * <BottomSafeArea>
 *   ...
 * </BottomSafeArea>
 */
export const BottomSafeArea: FC<BottomSafeAreaProps> = ({
  children,
  defaultProps,
  ...props
}) => {
  useSafeAreaFooterSetting(props, defaultProps)
  return <Box>{children}</Box>
}
